// common/schemas/collections/forms.js
import { z } from "zod";

const FormSubmissionSchema = z.object({
    _id: z.string().optional(),
    formType: z.enum([
        "HazardObservation",
        "IncidentReport",
        "NearMissObservation",
        "WorksiteSafetyInspection",
        "Suggestion",
        "PpeRequest"
    ]), // Add other form types as needed
    formData: z.object({}).passthrough(), // Allow any structure, validated per formType
    userId: z.string(),
    projectId: z.string().optional(), // Assuming projects are tracked
    status: z.enum([
        "submitted",
        "aiReviewed",
        "needsRevision",
        "pendingSupervisorReview",
        "approved",
        "rejected",
        "draft",
        "pending Submission",
        "processed"
    ]),
    createdAt: z.date(),
    updatedAt: z.date(),
    submittedBy: z.object({
        _id: z.string(),
        username: z.string(),
    }),
    assignedTo: z.string().nullable().optional(), // User ID of assigned supervisor/reviewer
    validationResults: z.object({
        isValid: z.boolean().optional(),
        feedback: z.string().optional(),
        severity: z.enum(["low", "medium", "high"]).optional(),
        categories: z.array(z.string()).optional(),
    }).optional(),
    workflowInstanceId: z.string().optional(),
    pdfUrl: z.string().url().optional(), // URL to the generated PDF
    statusHistory: z.array(
        z.object({
            status: z.string(),
            updatedBy: z.string(), // Could be a userId or "AI"
            timestamp: z.date(),
            comments: z.string().optional(),
        })
    ).optional(),
    canResubmit: z.boolean().default(true), // Add canResubmit flag
});

export default FormSubmissionSchema;